export default __webpack_public_path__ + "images/0x154f5db4950d2cd4a7af425e11865215f90ddb07.png";